import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import { Close } from '@material-ui/icons/'
import CancelIcon from '@material-ui/icons/Cancel'
import { Invitation } from 'apis/invitation'
import DummyHeader from '../../images/dummy_header.jpg'
import DefaultUserIcon from 'images/default_user_icon.jpg'

interface ErrorMessage {
  title: string
  description: string
}
interface ErrorMessages {
  [key: string]: ErrorMessage
}
const errorMessages: ErrorMessages = {
  expired: {
    title: '招待リンクの有効期限が切れています',
    description: 'お手数ですがリンクの再発行をオーナーへご依頼ください'
  },
  limit: {
    title: '招待上限人数を超えています',
    description:
      'お手数ですが、参加できるプランの\nリンク再発行をオーナーへご依頼ください'
  },
  plan_not_exists: {
    title: '招待されたプランが存在しません',
    description:
      'お手数ですが、参加可能なプランの\nリンク再発行をオーナーへご依頼ください'
  },
  plan_limit: {
    title: 'プランの参加上限人数を超えています',
    description:
      'お手数ですが、参加可能なプランの\nリンク再発行をオーナーへご依頼ください'
  },
  not_found: {
    title: '招待されたサロンが存在しません',
    description:
      'お手数ですが、参加可能なサロンのリンクを発行するようオーナーへご連絡ください'
  }
}
interface Props {
  invitation: Invitation
  setInvitation: Function
  onClose: Function
}
export default function InvitationNotificationModal(props: Props) {
  const [openInvitationNotificationModal, setOpenInvitationNotificationModal] =
    useState(true)
  const invitation = props.invitation

  const handleCloseModal = () => {
    props.onClose()
    setOpenInvitationNotificationModal(false)
    props.setInvitation(null)
  }
  useEffect(() => {}, [])
  return (
    <>
      <Dialog open={openInvitationNotificationModal} onClose={handleCloseModal}>
        <section className="modal invitationConfirmModal" id="modal-door">
          <div className="close modal-close">
            <CancelIcon onClick={handleCloseModal} color="disabled" />
          </div>
          {invitation.valid ? (
            <div className="invitationConfirmModal__header">
              <h2 className="invitationConfirmModal__title">
                新規登録、またはログイン後
                <br />
                招待されたサロンに参加できます
              </h2>
            </div>
          ) : (
            <>
              {invitation.error && (
                <div className="invitationConfirmModal__header">
                  <h2 className="invitationConfirmModal__title -error">
                    {errorMessages[invitation.error].title}
                  </h2>
                  <p className="invitationConfirmModal__description">
                    {errorMessages[invitation.error].description}
                  </p>
                </div>
              )}
            </>
          )}
          {invitation.door && (
            <div className="invitationConfirmModalSalonSummary">
              <figure className="invitationConfirmModalSalonSummary__image">
                <img
                  src={invitation.door.header_image_url}
                  onError={(e) => {
                    let target = e.target as HTMLImageElement
                    target.src = DummyHeader
                  }}
                  alt="header_image"
                />
              </figure>
              <div className="invitationConfirmModalSalonSummaryContent">
                <h3 className="invitationConfirmModalSalonSummary__title">
                  {invitation.door.title}
                </h3>
                <div className="invitationConfirmModalSalonSummaryOwner">
                  <img
                    src={invitation.door.icon_image_url || DefaultUserIcon}
                    alt={invitation.door.door_screen_name}
                    className="invitationConfirmModalSalonSummaryOwner__image"
                  />
                  <p className="invitationConfirmModalSalonSummaryOwner__text">
                    {invitation.door.door_screen_name}
                  </p>
                </div>
              </div>
            </div>
          )}
        </section>
      </Dialog>
    </>
  )
}
